/* eslint-disable react/no-did-update-set-state */
import React from 'react';
import PropTypes from 'prop-types';
import createReactClass from 'create-react-class';
import { registerField } from 'core/forms';

import FormFieldTextEditor from '../components/formFieldTextEditor';

const FormFieldTextEditorContainer = createReactClass({
  propTypes: {
    value: PropTypes.string,
    updateFields: PropTypes.func,
    fieldId: PropTypes.string.isRequired,
    fieldKey: PropTypes.string.isRequired,
    schema: PropTypes.shape({
      placeholder: PropTypes.string,
      textEditorOptions: PropTypes.object,
    }),
  },

  getDefaultProps() {
    return {
      value: '',
      updateFields: () => {},
      schema: {
        placeholder: '',
        textEditorOptions: {},
      },
    };
  },

  getInitialState() {
    return { isEditorChange: false };
  },

  componentDidMount() {
    this.setValue();
  },

  componentDidUpdate() {
    this.setValue();
  },

  onEditorLoad(api) {
    this.editorApi = api;
  },

  onEditorChange(newContent) {
    const { updateFields, fieldKey } = this.props;

    this.setState({ isEditorChange: true });
    updateFields({ [`${fieldKey}`]: newContent });
    this.setState({ isEditorChange: false });
  },

  setValue() {
    if (this.state.isEditorChange || !this.editorApi) return;

    const editorValue = this.editorApi.getValue();
    const value = this.props.value ?? '';

    if (editorValue !== value) {
      this.editorApi.setValue(value);
    }
  },

  render() {
    const { value, fieldId, schema } = this.props;

    return (
      <FormFieldTextEditor
        placeholder={schema.placeholder}
        value={value ?? ''}
        onEditorLoad={this.onEditorLoad}
        onEditorChange={this.onEditorChange}
        fieldId={fieldId}
        textEditorOptions={schema.textEditorOptions}
      />
    );
  },
});

registerField('TextEditor', React.memo(FormFieldTextEditorContainer));

export default FormFieldTextEditorContainer;
